/*
 * @Author: 廿夕 xuanwei@cai-inc.com
 * @Date: 2023-03-07 14:03:19
 * @LastEditors: 廿夕
 * @LastEditTime: 2023-03-23 11:53:49
 * @Description: 
 */
import { query } from 'src/utils/request';

const urls = {
  messageList: '/zlb/budget/info/query-relation-budget', // 获取消息列表
  markDeal: '/zlb/budget/info/query-relation-budget', // 标记已处理
};

export async function getMessageList (data) {
  return query(urls.messageList, { method: 'POST', data });
}

export async function markMessageDeal (data) {
  return query(urls.markDeal, { method: 'POST', data });
}

